// extracted by mini-css-extract-plugin
export default {"root":"B1gNn","drawer":"BxYTL","content":"VS4KX","header":"LQFsA","title":"GohaQ","buttonsWrapper":"GcCup","close":"Kww4J","closeIcon":"bgLSW","modalTitle":"jHxv7"};